<template>
	<div class="flex flex--gap-medium form__input-wrapper">
		<label
			class="invisible"
			:for="inputId + '-day'"
		>
			Day
		</label>
		<input
			:id="inputId + '-day'"
			v-model="day"
			type="text"
			pattern="[0-9]*"
			inputmode="numeric"
			class="form__input form__input--med form__input--simple-number"
			:class="error ? 'form__input--error' : ''"
			@input="emitUpdated"
			@keyup="nextDateInput"
		>
		<label
			class="invisible"
			:for="inputId + '-month'"
		>
			Month
		</label>
		<input
			:id="inputId + '-month'"
			v-model="month"
			type="text"
			pattern="[0-9]*"
			inputmode="numeric"
			class="form__input form__input--med form__input--simple-number"
			:class="error ? 'form__input--error' : ''"
			@input="emitUpdated"
			@keyup="nextDateInput"
		>
		<label
			class="invisible"
			:for="inputId + '-year'"
		>
			Year
		</label>
		<input
			:id="inputId + '-year'"
			v-model="year"
			type="text"
			pattern="[0-9]*"
			inputmode="numeric"
			class="form__input form__input--med form__input--simple-number"
			:class="error ? 'form__input--error' : ''"
			@input="emitUpdated"
		>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';

const day = ref( null );
const month = ref( null );
const year = ref( null );

const props = defineProps( {
	value: {
		required: true,
		type: [ String, Number, Boolean ]
	},
	inputId: {
		required: true,
		type: String
	},
	error: {
		required: false,
		type: Boolean,
		default: false
	}
} );

const complete_date = computed( () => {
	if ( day.value && month.value && year.value ) {
		return `${year.value}-${month.value}-${day.value}`;
	}

	return null;
} );

onMounted( () => {
	if ( null === props.value ) {
		return;
	}

	const parts = props.value.split( '-' );
	if ( parts.length === 3 ) {
		// We're storing it Y-m-d
		year.value = parts[0];
		month.value = parts[1];
		day.value = parts[2];
	}
} );

const emit = defineEmits( ['updated'] );

function emitUpdated() {
	emit( 'updated', complete_date.value );
}

function nextDateInput( event ) {
	if ( ( event.key !== 'Tab' && event.key !== 'Shift' ) && ( event.target.value.length === 2 ) ) {
		event.target.nextElementSibling.focus();
	}
}

</script>
